import { defineAgenda, param, type ParamCodec } from '@/shared/navigation/core';

/** Codec pro měsíc ve tvaru 'YYYY-MM' */
const monthCodec: ParamCodec<string> = {
  encode: (value) => value,
  decode: (raw) => {
    if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(raw)) {
      throw new Error(`Invalid month: ${raw}`);
    }
    return raw;
  },
};

/**
 * Root agenda „Kalendář zájezdů" — běžná (overlay) agenda s měsíčním kalendářem termínů.
 * `month` a `transport` drží navigační stav (deep-link / reload), `termId` otevřený drawer termínu.
 */
export const calendarAgenda = defineAgenda({
  id: 'app.planner-calendar',
  path: 'app/planner-calendar',
  open: {},
  state: {
    month: param.custom(monthCodec).optional(),
    transport: param.enum(['all', 'air', 'coach'] as const).optional(),
    termId: param.uuid().optional(),
  },
  title: 'Kalendář zájezdů',
  icon: 'calendar',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
